import { SortingState } from "@tanstack/react-table";
import { createContext, useContext } from "react";
import { createStore, useStore } from "zustand";
import { combine } from "zustand/middleware";

const createArchiveUiStore = () =>
  createStore(
    combine(
      {
        displayRouteSidebar: false,
        displayFilterSidebar: false,
        sortState: [] as SortingState,
      },
      (set) => ({
        setDisplayRouteSidebar: (displayRouteSidebar: boolean) => set({ displayRouteSidebar }),
        setDisplayFilterSidebar: (displayFilterSidebar: boolean) => set({ displayFilterSidebar }),
        setSortState: (sortState: SortingState) => set({ sortState }),
      }),
    ),
  );

const ArchiveUiStoreContext = createContext<ReturnType<typeof createArchiveUiStore> | undefined>(
  undefined,
);

export function ArchiveUiStoreProvider({ children }: { children: React.ReactNode }) {
  const store = createArchiveUiStore();
  return <ArchiveUiStoreContext.Provider value={store}>{children}</ArchiveUiStoreContext.Provider>;
}

type ArchiveUiStoreState = ReturnType<ReturnType<typeof createArchiveUiStore>["getState"]>;

export function useArchiveUiStore(): ArchiveUiStoreState;
export function useArchiveUiStore<T>(selector: (state: ArchiveUiStoreState) => T): T;
export function useArchiveUiStore<T>(selector?: (state: ArchiveUiStoreState) => T) {
  const store = useContext(ArchiveUiStoreContext);
  if (!store) {
    throw new Error("useArchiveUiStore must be used within a ArchiveUiStoreProvider");
  }
  return useStore(store, selector ?? ((state) => state as T));
}
